import React from 'react'
import styled from 'styled-components'

import { StatList, S_StatList, S_StatLists_Wrapper } from '../../../_components/StatList'

export const S_InvoiceSummary = styled.div`
  ${S_StatList} {
    margin-bottom: 20px;
  }
`

export const InvoiceSummary = ({ invoice, debtor_name, debtorId, layout = 'summary' }) => {
  if (!invoice) {
    return null
  }

  if (debtor_name === null) {
    return ''
  }

  const { age, balance, face_value, invoice_date, invoice_number, po_number } = invoice

  const summaryItems = [
    {
      label: 'Debtor',
      value: debtor_name,
      type: 'link',
      options: {
        to: `/debtor_details/${debtorId}`,
      },
    },
    {
      label: 'Invoice Number',
      value: invoice_number,
    },
    {
      label: 'Invoice Balance',
      value: balance,
      type: 'currency',
    },
    {
      label: 'Invoice Amount',
      value: face_value,
      type: 'currency',
    },
    {
      label: 'Purchase Order',
      value: po_number || '–',
    },
    {
      label: 'Invoice Date',
      value: invoice_date,
      type: 'truncatedDate',
      tooltip: `Age is ${age} days`,
    },
  ]

  // <-
  return (
    <S_StatLists_Wrapper>
      <S_InvoiceSummary>
        <StatList items={summaryItems} layout={layout} />
      </S_InvoiceSummary>
    </S_StatLists_Wrapper>
  )
}
